function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.567 2.919a.478.478 0 0 0-.486.486v2.919a.487.487 0 1 0 .973 0V3.405a.478.478 0 0 0-.487-.486z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.568 0a4.884 4.884 0 0 0-4.735 3.73H2.108A2.1 2.1 0 0 0 0 5.838v10.054A2.1 2.1 0 0 0 2.108 18h12.973a2.087 2.087 0 0 0 2.108-1.946v-6.6A4.866 4.866 0 0 0 15.568 0zm-3.1 10.9a6.9 6.9 0 0 1-3.876 1.751c-2.822 0-6.162-3.924-6.308-4.086a.471.471 0 0 1 .065-.681.485.485 0 0 1 .681.065 17.321 17.321 0 0 0 1.93 1.914 6.449 6.449 0 0 0 3.632 1.816 5.909 5.909 0 0 0 3.276-1.541.485.485 0 0 1 .6.762zm3.1-2.141a3.892 3.892 0 1 1 3.892-3.892 3.9 3.9 0 0 1-3.892 3.89z"
});

function SvgNewMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.432,
    height: 18,
    viewBox: "0 0 20.432 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/new-message.897057e2.svg";
export { ForwardRef as ReactComponent };